export const ProductData = [
    {
        title:'랜더스 최정 17년 연속 \n 두 자릿수  홈런 기념 유니폼',
        price:'115,000',
        discountPrice:'92,000',
        event:true,
        new:true,
        soldout:true,
        disccountRate :'20%',
        img:`${process.env.PUBLIC_URL}/images/dbdb9d6e-7156-4108-8a44-872e5eeb653420250717.png`,
    },
    {
        title:'랜더스 인천 긴팔 아노락',
        price:'90,000',
        discountPrice:'90,000',
        event:true,
        new:true,
        discount:true,
        soldout:false,
        disccountRate :'20%',
        img:`${process.env.PUBLIC_URL}/images/6b3ae2ba-68f5-4999-91ef-1b92c5f8732a20250321.jpg`,
    },
    {
        title:'25 랜더스 어센틱 \n뉴 옐로우 에디션 유니폼',
        price:'145,000',
        discountPrice:'105,000',
        event:false,
        new:true,
        soldout:false,
        disccountRate :'20%',
        img:`${process.env.PUBLIC_URL}/images/08449715-ee10-43d1-aeed-f4ce95b200ee20250501.jpg`,
    },
    {
        title:'랜더스 리사이클 그린 유니폼',
        price:'119,000',
        discountPrice:'119,000',
        event:false,
        new:true,
        soldout:false,
        disccountRate :'20%',
        img:`${process.env.PUBLIC_URL}/images/5a65117e-906e-4b98-b1d7-374057778dc920250311.jpg`,
    },
]

export const SpecialItem = [
    {
        title:'[예약판매] 김강민 은퇴 기념 유니폼',
        price:'149,000',
        discountPrice:'92,000',
        event:false,
        new:true,
        soldout:true,
        disccountRate :'20%',
        img:`${process.env.PUBLIC_URL}/images/8da98346-cdbf-402e-ba5d-d71c63db3d6a20250627.png`,
    },
    {
        title:'[예약판매] 김강민 은퇴 기념 모자',
        price:'42,000',
        discountPrice:'42,000',
        event:true,
        new:true,
        discount:true,
        soldout:false,
        disccountRate :'20%',
        img:`${process.env.PUBLIC_URL}/images/2e2e1087-62d8-4dba-a03c-638f858a8bec20250627.png`,
    },
    {
        title:'[예약판매] 김강민 은퇴 기념구',
        price:'23,000',
        discountPrice:'23,000',
        event:false,
        new:true,
        soldout:false,
        disccountRate :'20%',
        img:`${process.env.PUBLIC_URL}/images/82d4fdd2-854d-4dc2-93d3-1ebb78f711ac20250627.png`,
    },
    {
        title:'[예약판매] 김강민 은퇴 기념 아크릴 키링',
        price:'10,000',
        discountPrice:'10,000',
        event:false,
        new:true,
        soldout:false,
        disccountRate :'20%',
        img:`${process.env.PUBLIC_URL}/images/a2111ae1-3f09-474e-acdc-481df57ced1b20250627.png`,
    },
]

export const Goods = [
    {
        title:'랜더스 로고볼',
        price:'7,000',
        discountPrice:'7,000',
        event:false,
        new:false,
        soldout:false,
        disccountRate :'0%',
        img:`${process.env.PUBLIC_URL}/images/9ab46cde-155a-493c-aee6-1f3f78036ed320250529.jpg`,
    },
    {
        title:'랜더스 X 깜자 인형',
        price:'35,000',
        discountPrice:'35,000',
        event:true,
        new:true,
        discount:true,
        soldout:false,
        disccountRate :'20%',
        img:`${process.env.PUBLIC_URL}/images/60e50fd4-c131-4a42-806b-3666d158713120250516.png`,
    },
    {
        title:'랜더스 인천군 버클캡',
        price:'42,000',
        discountPrice:'42,000',
        event:false,
        new:true,
        soldout:false,
        disccountRate :'20%',
        img:`${process.env.PUBLIC_URL}/images/7b6b2017-00e4-4505-98c6-d2d2da9f0e9920240514.jpg`,
    },
    {
        title:'랜더스 핸디 선풍기',
        price:'29,000',
        discountPrice:'29,000',
        event:false,
        new:true,
        soldout:false,
        disccountRate :'20%',
        img:`${process.env.PUBLIC_URL}/images/35c7879f-3893-4de7-809a-c473b1b1c87220240724.jpg`,
    },
]
